import {
  FORM_INFO,
  HEADINGS,
} from "@/app/(withNavbarOnly)/care-assessment/v1/constants";
import {
  B2cType,
  ServiceCategories,
  Steps,
} from "@/app/(withNavbarOnly)/care-assessment/v1/assessment-store";

export const getHeading = (
  step: Steps,
  serviceCategory: ServiceCategories,
  b2cType?: B2cType
): string => {
  const index = b2cTypeValuesToIndex(b2cType);

  return serviceCategory === "services-for-families"
    ? HEADINGS[step][serviceCategory][index]
    : HEADINGS[step][serviceCategory];
};

export const getFormInfo = (
  step: Steps,
  serviceCategory: ServiceCategories,
  b2cType?: B2cType
): {
  type: string;
  text: string;
  value: string;
  radioGroup?: string;
  description?: string;
}[] => {
  const index = b2cTypeValuesToIndex(b2cType);

  return serviceCategory === "services-for-families"
    ? FORM_INFO[step][serviceCategory][index]
    : FORM_INFO[step][serviceCategory];
};

export const b2cTypeValuesToIndex = (values?: B2cType) => {
  if (!values || values.length <= 0) return "default";
  else if (values.length > 1) return "both";
  else if (values[0] === "Medical Care") return "medical";
  else return "non-medical";
};
